import {
  RefObject,
  useCallback,
  useEffect,
  useState,
} from 'react';

type UseOverflowDetectionProps<T> = {
  ref: RefObject<T>;
};
const useOverflowDetection = <T extends HTMLElement>({
  ref,
}: UseOverflowDetectionProps<T>): boolean => {
  const [canScroll, setCanScroll] = useState(false);
  const update = useCallback(() => {
    if (!ref.current) {
      return;
    }
    const element = ref.current;
    setCanScroll(element.scrollHeight > element.clientHeight);
  }, [ref]);

  useEffect(() => {
    update();
    // Element may change size dynamically
    const observer = new ResizeObserver(update);
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [update, ref]);

  return canScroll;
};

export default useOverflowDetection;
